import { Controller } from "@hotwired/stimulus"

// The control that last submitted, so the form rendered in response (for example inside a Turbo
// Frame, which replaces the form) can return keyboard focus to it. Ignored after a few seconds.
let pendingFocus = null
const FOCUS_WINDOW_MS = 5000

// Submits the form as soon as a control changes. Keep a <noscript> submit button in the form
// for browsers without JavaScript.
// Connects to data-controller="auto-submit"
export default class extends Controller {
  connect() {
    if (!pendingFocus || Date.now() - pendingFocus.at > FOCUS_WINDOW_MS) return

    const control = this.element.querySelector(`#${CSS.escape(pendingFocus.id)}`)
    if (!control) return

    pendingFocus = null
    control.focus({ preventScroll: true })
  }

  submit(event) {
    const id = event?.target?.id
    pendingFocus = id ? { id, at: Date.now() } : null
    this.element.requestSubmit()
  }
}
